(function (root, factory) {
  var api = factory();

  if (typeof module === "object" && module.exports) {
    module.exports = api;
  }

  root.MCProductVariantPicker = api;
})(typeof window !== "undefined" ? window : globalThis, function () {
  function optionKey(position) {
    return "option" + String(position);
  }

  function normalizePosition(position) {
    var normalized = Number.parseInt(position, 10);
    return Number.isFinite(normalized) ? normalized : null;
  }

  function selectedValueForPosition(selectedOptions, position) {
    if (!selectedOptions) {
      return undefined;
    }

    return selectedOptions[String(position)] || selectedOptions[position];
  }

  function selectedPositions(selectedOptions) {
    if (!selectedOptions) {
      return [];
    }

    return Object.keys(selectedOptions)
      .map(normalizePosition)
      .filter(function (position) {
        return position !== null;
      })
      .sort(function (a, b) {
        return a - b;
      });
  }

  function variantMatchesPositions(variant, selectedOptions, positions) {
    return positions.every(function (position) {
      var selectedValue = selectedValueForPosition(selectedOptions, position);

      if (!selectedValue) {
        return true;
      }

      return variant[optionKey(position)] === selectedValue;
    });
  }

  function findExactVariant(variants, selectedOptions) {
    if (!Array.isArray(variants)) {
      return null;
    }

    var positions = selectedPositions(selectedOptions);

    return (
      variants.find(function (variant) {
        return variantMatchesPositions(variant, selectedOptions, positions);
      }) || null
    );
  }

  function findBestAvailableVariant(
    variants,
    selectedOptions,
    changedPosition
  ) {
    if (!Array.isArray(variants)) {
      return null;
    }

    var exactVariant = findExactVariant(variants, selectedOptions);

    if (exactVariant && exactVariant.available) {
      return exactVariant;
    }

    var normalizedChangedPosition = normalizePosition(changedPosition);

    if (normalizedChangedPosition === null) {
      return null;
    }

    var prefixPositions = selectedPositions(selectedOptions).filter(
      function (position) {
        return position <= normalizedChangedPosition;
      }
    );

    return (
      variants.find(function (variant) {
        return (
          variant.available &&
          variantMatchesPositions(variant, selectedOptions, prefixPositions)
        );
      }) || null
    );
  }

  function isOptionValueAvailable(
    variants,
    selectedOptions,
    optionPosition,
    optionValue
  ) {
    if (!Array.isArray(variants)) {
      return false;
    }

    var normalizedOptionPosition = normalizePosition(optionPosition);

    if (normalizedOptionPosition === null) {
      return false;
    }

    var prefixPositions = selectedPositions(selectedOptions).filter(
      function (position) {
        return position < normalizedOptionPosition;
      }
    );

    return variants.some(function (variant) {
      return (
        variant.available &&
        variant[optionKey(normalizedOptionPosition)] === optionValue &&
        variantMatchesPositions(variant, selectedOptions, prefixPositions)
      );
    });
  }

  return {
    findBestAvailableVariant: findBestAvailableVariant,
    findExactVariant: findExactVariant,
    isOptionValueAvailable: isOptionValueAvailable,
    optionKey: optionKey,
  };
});
